export const CREATE_PAGE_VIEWER = 'Jigsaw.createPageViewer';
export const GET_BOOK_LIST = 'Jigsaw.getBookList';
export const NEXT_PAGE = 'Book.goToNextPage';
export const PREV_PAGE = 'Book.goToPreviousPage';
export const HAS_NEXT_PAGE = 'Book.hasNextPage';
export const HAS_PREV_PAGE = 'Book.hasPreviousPage';
export const GET_NEXT_PAGE = 'Book.getNextPage';
export const GET_PREV_PAGE = 'Book.getPreviousPage';
export const GET_TOC = 'Book.getTOC';
export const GET_BOOKMARKS = 'Book.getBookmarks';
export const GET_HIGHLIGHTS = 'Book.getHighlights';
export const GET_USER_INFO = 'Jigsaw.User.getInfo';
export const SIGN_OUT = 'Jigsaw.User.signOut';
export const GO_TO_PAGE = 'Book.goToPage';
export const SEARCH_CONTENT = 'Book.searchContent';
export const GO_TO_CFI = 'Book.goToCFI';
export const GO_TO_SEARCH_RESULT = 'Book.goToSearchResult';
export const HIGHLIGHT_CURRENT = 'Book.highlightCurrentSelection';
export const DELETE_HIGHLIGHT = 'Book.deleteHighlight';
export const UPDATE_HIGHLIGHT = 'Book.updateHighlight';
export const GO_TO_HIGHLIGHT = 'Book.goToHighlight';
export const SET_BOOKMARK = 'Book.setBookmark';
export const DELETE_BOOKMARK = 'Book.deleteBookmark';
export const GET_THUMBNAILS = 'Book.getThumbnails';
export const SET_ZOOM_SCALE = 'Book.setZoomScale';
export const HIGHLIGHT_TERM = 'Book.highlightTerm';
export const UNHIGHLIGHT_TERMS = 'Book.unhighlightTerms';
export const INCREASE_ZOOM = 'Book.increaseZoomScale';
export const DECREASE_ZOOM = 'Book.decreaseZoomScale';
export const TTS_V2_START = 'TTS.startFromTop';
export const TTS_V2_PAUSE = 'TTS.pause';
export const TTS_V2_RESUME = 'TTS.resume';
export const TTS_V2_CANCEL = 'TTS.cancel';
export const TTS_V2_NEXT = 'TTS.skipForward';
export const TTS_V2_PREV = 'TTS.skipBack';
export const TTS_V2_SET_VOICE = 'TTS.setVoice';
export const TTS_V2_SEND_STATUS = 'TTS.sendStatus';
export const TTS_V2_SET_NO_CONTENT_MSG = 'TTS.setNoContentMessage';
export const TTS_V2_GET_VOICES = 'TTS.getVoices';
export const DESTROY = 'destroy';
export const DISABLE_SCROLLING = 'Book.disableScrolling';
export const ENABLE_SCROLLING = 'Book.enableScrolling';
export const UPDATE_LICENSE = 'Jigsaw.User.updateLicense';
export const GET_DEVICES = 'Jigsaw.User.getDevices';
export const DEACTIVATE_DEVICE = 'Jigsaw.User.deactivateDevice';
export const GET_CITATION = 'Book.getCitationInfo';
export const GET_PAGE_BREAKS = 'Book.getPageBreaks';
export const GO_TO_BOOKMARK = 'Book.goToBookmark';
export const GENERATE_CAPTCHA = 'Jigsaw.User.generateCaptcha';
export const CLEAR_SELECTION = 'Book.clearSelection';
export const DISABLE_ZOOM = 'Viewport.zoomDisabled';
export const SSO = 'Jigsaw.User.SSO';
export const SET_USER_INFO = 'Jigsaw.User.setInfo';
export const GET_NOTES = 'Book.getNotes';
export const ADD_NOTE = 'Book.addNote';
export const UPDATE_NOTE = 'Book.updateNote';
export const DELETE_NOTE = 'Book.deleteNote';
export const GET_ANCILLARIES = 'Book.getAncillaries';
export const SET_DPS = 'Viewport.setDPS';
export const SCROLL_TO_TOP = 'Viewport.scrollToTop';
export const SCROLL_TO_LEFT = 'Viewport.scrollToLeft';
